var map = {
	"./aboutUs.js": 2870,
	"./account.js": 2871,
	"./address.js": 2872,
	"./bindForm.js": 2873,
	"./careers.js": 2874,
	"./check.js": 2875,
	"./classChangeRules.js": 2876,
	"./common.js": 2877,
	"./competitionMall.js": 2878,
	"./courses.js": 2879,
	"./coursesDetail.js": 2880,
	"./download.js": 2881,
	"./evaluation.js": 2882,
	"./freeAssessment.js": 2883,
	"./goods.js": 2884,
	"./home.js": 2885,
	"./index.js": 2868,
	"./internetSafetyTips.js": 2886,
	"./login.js": 2887,
	"./order.js": 2888,
	"./ourCourses.js": 2889,
	"./page.js": 2890,
	"./privacyPolicy.js": 2891,
	"./refundPolicy.js": 2892,
	"./resources.js": 2893,
	"./seo.js": 2894,
	"./teacher.js": 2895,
	"./termsOfUse.js": 2896,
	"./test.js": 2897,
	"./unpaidCourses.js": 2898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2869;